import React, { memo, useEffect, useRef } from "react";
import s from "../CameraZonesView.less";
import {
  CameraCheck,
  CameraCheckStatus,
  useGetCameraCheckListLazyQuery,
} from "~/schemas/generated/graphql";
import { useSelectorDataConfigurator } from "~/hooks/selectorDataConfigurator";
import {
  useURLParamsGetter,
  useURLParamsSetter,
} from "~/hooks/useURLParamsSetter";
import StatusResolver from "~/pages/CameraZonesView/parts/StatusResolver";
import Preloader from "~/components/Preloader";
import { useIntersectionObserver } from "~/hooks/useIntersectionObserver";

interface IDialog {
  id: string;
  name: string;
  status: CameraCheckStatus;
}

const CameraCheckHistory = () => {
  const { cameraId } = useURLParamsGetter<{ cameraId: string }>();
  const setParams = useURLParamsSetter();
  const intersectionObserverItemRef = useRef<HTMLDivElement>(null);
  const paginateTrigger = useIntersectionObserver({
    target: intersectionObserverItemRef,
  });

  const cameraCheckList = useSelectorDataConfigurator<CameraCheck, IDialog>({
    queryGenerator: useGetCameraCheckListLazyQuery,
    customDecoratedValueHandler: ({ id, name, status }) => ({
      id,
      name,
      status,
    }),
    responseDataGetterString: "CameraGetter.getCameraChecks.items",
    additionQueryParameters: { cameraId: Number(cameraId) },
    fetchPolicy: "no-cache",
    count: 15,
  });

  useEffect(() => {
    if (paginateTrigger) cameraCheckList.introspectionHandler();
  }, [paginateTrigger]);

  return (
    <div className={s.historyContainer}>
      {cameraCheckList.rowsForSelect.length ? (
        cameraCheckList.rowsForSelect.map(({ id, name, status }) => (
          <div
            key={id}
            className={s.historyItem}
            onClick={() => setParams({ dialog: id })}
          >
            <span>{name}</span>
            <StatusResolver status={status} />
          </div>
        ))
      ) : (
        <div className={s.emptyHistory}>
          {cameraCheckList.dataRequestLoading ? (
            <Preloader />
          ) : (
            <p>История замечаний пуста</p>
          )}
        </div>
      )}
      <div ref={intersectionObserverItemRef} />
    </div>
  );
};

export default memo(CameraCheckHistory);
